import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component, Fragment } from 'react';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import collapseRangeHelper from '../util/collapseRange';
import { LeftNavigator, RightNavigator } from './Navigators';
import PageComponent from './Page';
import renderDefaultEllipsis from './renderEllipsis';
const packageName = "@atlaskit/pagination";
const packageVersion = "13.1.0";

class Pagination extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      selectedIndex: this.props.defaultSelectedIndex || 0
    });

    _defineProperty(this, "createAndFireEventOnAtlaskit", createAndFireEvent('atlaskit'));

    _defineProperty(this, "onChangeAnalyticsCaller", () => {
      const {
        createAnalyticsEvent
      } = this.props;

      if (createAnalyticsEvent) {
        return this.createAndFireEventOnAtlaskit({
          action: 'changed',
          actionSubject: 'pageNumber',
          attributes: {
            componentName: 'pagination',
            packageName,
            packageVersion
          }
        })(createAnalyticsEvent);
      }

      return undefined;
    });

    _defineProperty(this, "onChange", (event, newSelectedPage) => {
      if (this.props.selectedIndex === undefined) {
        this.setState({
          selectedIndex: newSelectedPage
        });
      }

      const analyticsEvent = this.onChangeAnalyticsCaller();

      if (this.props.onChange) {
        this.props.onChange(event, this.props.pages[newSelectedPage], analyticsEvent);
      }
    });

    _defineProperty(this, "pagesToComponents", pages => {
      const {
        selectedIndex
      } = this.state;
      const {
        components,
        getPageLabel
      } = this.props;
      return pages.map((page, index) => {
        return /*#__PURE__*/React.createElement(PageComponent, {
          key: `page-${getPageLabel ? getPageLabel(page, index) : index}`,
          component: components.Page,
          onClick: event => this.onChange(event, index),
          isSelected: selectedIndex === index,
          page: page
        }, getPageLabel ? getPageLabel(page, index) : page);
      });
    });

    _defineProperty(this, "renderPages", () => {
      const {
        selectedIndex
      } = this.state;
      const {
        pages,
        max,
        collapseRange,
        renderEllipsis
      } = this.props;
      const pagesComponents = this.pagesToComponents(pages); // @ts-ignore

      return collapseRange(pagesComponents, selectedIndex, {
        max: max,
        ellipsis: renderEllipsis
      });
    });

    _defineProperty(this, "renderLeftNavigator", () => {
      const {
        components,
        pages,
        i18n
      } = this.props;
      const {
        selectedIndex
      } = this.state;
      const props = {
        'aria-label': i18n.prev,
        pages
      };
      return /*#__PURE__*/React.createElement(LeftNavigator, _extends({
        key: "left-navigator",
        component: components.Previous,
        onClick: event => this.onChange(event, selectedIndex - 1),
        isDisabled: selectedIndex === 0
      }, props));
    });

    _defineProperty(this, "renderRightNavigator", () => {
      const {
        components,
        pages,
        i18n
      } = this.props;
      const {
        selectedIndex
      } = this.state;
      const props = {
        'aria-label': i18n.next,
        pages
      };
      return /*#__PURE__*/React.createElement(RightNavigator, _extends({
        key: "right-navigator",
        component: components.Next,
        onClick: event => this.onChange(event, selectedIndex + 1),
        isDisabled: selectedIndex === pages.length - 1
      }, props));
    });
  }

  static getDerivedStateFromProps(props) {
    // selectedIndex is controlled
    if (props.selectedIndex != null) {
      return {
        selectedIndex: props.selectedIndex
      };
    }

    return null;
  }

  render() {
    const {
      innerStyles,
      testId
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": testId,
      style: {
        display: 'flex',
        ...innerStyles
      }
    }, /*#__PURE__*/React.createElement(Fragment, null, this.renderLeftNavigator(), this.renderPages(), this.renderRightNavigator()));
  }

}

_defineProperty(Pagination, "defaultProps", {
  collapseRange: collapseRangeHelper,
  components: {},
  defaultSelectedIndex: 0,
  i18n: {
    prev: 'previous',
    next: 'next'
  },
  innerStyles: {},
  max: 7,
  onChange: () => {},
  renderEllipsis: renderDefaultEllipsis
});

export default withAnalyticsContext({
  componentName: 'pagination',
  packageName,
  packageVersion
})(withAnalyticsEvents()(Pagination));